import React from "react";
import { Avatar, Box, Typography } from "@mui/material";
import { Description as DescriptionIcon } from "@mui/icons-material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DisplayText from "../DisplayText/DisplayText";
import { figureComponent } from "../../utils/MediaUtils";
import { IMedia } from "../../features/studies/studiesSlice";

interface MediaThumbnailProps {
    media: IMedia;
    size?: string;
    showLaterality?: boolean;
    onClick?: () => void;
}

const MediaThumbnail: React.FC<MediaThumbnailProps> = ({ media, size = "60px", showLaterality = true, onClick }) => {
    const src = media.mediaUrl;
    const component = figureComponent(media);

    const handleClick = () => {
        if (onClick) onClick();
    };

    const style = {
        width: size,
        height: size,
        objectFit: "cover" as const,
    };

    if (!component || !src) return null;

    switch (component) {
        case "img":
            return (
                <Box style={{ position: "relative", height: size }} onClick={handleClick}>
                    {showLaterality && (
                        <Avatar
                            aria-label="label"
                            sx={{
                                backgroundColor: "#736f4f",
                                color: "white",
                                position: "absolute",
                                marginTop: "5px",
                                marginLeft: "5px",
                                width: "20px",
                                height: "20px",
                            }}
                            variant="rounded"
                        >
                            <Typography sx={{ fontWeight: 1000, fontSize: "10px" }}>{media.laterality}</Typography>
                        </Avatar>
                    )}
                    <img alt={media.fileName} src={src} style={style} />
                </Box>
            );
        case "video":
            return (
                <Box style={{ position: "relative", height: size }} onClick={handleClick}>
                    {showLaterality && (
                        <Avatar
                            aria-label="label"
                            sx={{
                                backgroundColor: "#736f4f",
                                color: "white",
                                position: "absolute",
                                marginTop: "5px",
                                marginLeft: "5px",
                                width: "20px",
                                height: "20px",
                            }}
                            variant="rounded"
                        >
                            <Typography sx={{ fontWeight: 1000, fontSize: "10px" }}>{media.laterality}</Typography>
                        </Avatar>
                    )}
                    <video src={src} style={style} />
                </Box>
            );
        case "iframe":
            return (
                <Box
                    sx={{
                        display: "flex",
                        height: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                    }}
                    onClick={handleClick}
                >
                    <DescriptionIcon sx={{ width: "30px", height: "30px" }} />
                    <Typography sx={{ fontSize: "10px" }}>PDF</Typography>
                </Box>
            );
        case "attachment":
            return (
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                    }}
                    onClick={handleClick}
                >
                    <AttachFileIcon />
                    <DisplayText type="bodyXSmall" text={media.fileName.split(".").at(-1) || ""} />
                </Box>
            );
        default:
            return null;
    }
};

export default MediaThumbnail;
